/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AttachContactPersonToTownCommand
 */
export interface AttachContactPersonToTownCommand {
    /**
     * 
     * @type {string}
     * @memberof AttachContactPersonToTownCommand
     */
    contactPersonId: string;
    /**
     * 
     * @type {string}
     * @memberof AttachContactPersonToTownCommand
     */
    townId: string;
}

export function AttachContactPersonToTownCommandFromJSON(json: any): AttachContactPersonToTownCommand {
    return AttachContactPersonToTownCommandFromJSONTyped(json, false);
}

export function AttachContactPersonToTownCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttachContactPersonToTownCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contactPersonId': json['contactPersonId'],
        'townId': json['townId'],
    };
}

export function AttachContactPersonToTownCommandToJSON(value?: AttachContactPersonToTownCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contactPersonId': value.contactPersonId,
        'townId': value.townId,
    };
}


